import * as tslib_1 from "tslib";
import * as mailModuleOrchestrator from 'owa-mail-module-orchestrator';
import * as searchActions from 'owa-mail-search-actions';
import * as undoActions from 'owa-mail-undo';
import { lazyEndSearchSession, getScenarioStore, SearchScenarioId } from 'owa-search';
/**
 * Called after a node (Folder, Persona, Group) is selected in the folder forest
 */
export default function onAfterSelectingFolder(actionSource) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var endSearchSession;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    undoActions.clearLastUndoableAction();
                    searchActions.lazyOnSelectingFolder(actionSource);
                    if (!getScenarioStore(SearchScenarioId.Mail).searchSessionGuid) return [3 /*break*/, 2];
                    return [4 /*yield*/, lazyEndSearchSession.import()];
                case 1:
                    endSearchSession = _a.sent();
                    endSearchSession(SearchScenarioId.Mail);
                    _a.label = 2;
                case 2:
                    mailModuleOrchestrator.lazyOnSelectingFolder.importAndExecute();
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=onAfterSelectingNode.js.map